export enum ProfileActionTypes {
    API_RESPONSE_ERROR = '@@profile/API_RESPONSE_ERROR',
    API_RESPONSE_SUCCESS = '@@profile/API_RESPONSE_SUCCESS',
    USER_LOAD_PROFILE = '@@profile/USER_LOAD_PROFILE',

    RESET = '@@profile/RESET',
}
